export const musicList = [
  {
    imgSrc:
      'https://i.ytimg.com/vi/V_X8xgSZejo/mqdefault.jpg',
    title: 'Aboud abi - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=V_X8xgSZejo',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/2vDsy_5nQ7g/maxresdefault.jpg',
    title: 'Katerina - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=2vDsy_5nQ7g',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/25nAvBYAlxU/maxresdefault.jpg',
    title: 'Katapilla - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=25nAvBYAlxU',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/AyoJotEuxpI/maxresdefault.jpg',
    title: 'Bado - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=AyoJotEuxpI',
  },
];
export const videoList = [
  {
    imgSrc:
      'https://i.ytimg.com/vi/V_X8xgSZejo/mqdefault.jpg',
    title: 'Aboud abi - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=V_X8xgSZejo',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/2vDsy_5nQ7g/maxresdefault.jpg',
    title: 'Katerina - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=2vDsy_5nQ7g',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/25nAvBYAlxU/maxresdefault.jpg',
    title: 'Katapilla - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=25nAvBYAlxU',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/AyoJotEuxpI/maxresdefault.jpg',
    title: 'Bado - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=AyoJotEuxpI',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/p99i3PCNiIw/maxresdefault.jpg',
    title: 'Ikinyafu - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=p99i3PCNiIw',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/OEI_RBkp5EY/maxresdefault.jpg',
    title: 'Ikinya - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=OEI_RBkp5EY',
  },
  {
    imgSrc:
      'https://i.ytimg.com/vi/McxELUpizgI/maxresdefault.jpg',
    title: 'Saa Moya - Bruce melogy',
    releaseDate: 'May 20 2021',
    redirectedUrl: 'https://www.youtube.com/watch?v=McxELUpizgI',
  },

];

